import { Box } from "@mui/material";
import { endOfYear, getDayOfYear } from "date-fns";

import { ProtocolEditRoute_GetByIdQuery } from "../../routes/ProtocolEditRoute/queries.generated";
import PossibleVisitsForProtocol from "./PossibleVisitsForProtocol";

type Protocol = NonNullable<ProtocolEditRoute_GetByIdQuery["protocolGetById"]>;

type Props = {
    protocols: Protocol[];
};

export default function PossibleVisitsGraph({ protocols }: Props) {
    const yearLength = getDayOfYear(endOfYear(new Date("2025-09-01")));
    return (
        <Box sx={{ my: 2 }}>
            {protocols.map(protocol => (
                <PossibleVisitsForProtocol key={protocol.id} protocol={protocol} yearLength={yearLength} />
            ))}
        </Box>
    );
}
